import React from 'react';
import { ForfeituresReportdIcon } from '@common-fe/common-fe';

import { ROUTES } from '@/common';

import { useFavoriteReportHandler } from '../hooks';
import { ReportTypeKeys } from '../report.types';

import ReportCardBase, { ReportCardBaseProps } from './ReportCardBase';
interface Props extends ReportCardBaseProps {}
const TEST_ID = 'forfeiture-report-card';
const ForfeitureCard: React.FC<Props> = ({ isFavoriteMode }) => {
  const { isFavorite, handleToggleReportKey } = useFavoriteReportHandler(ReportTypeKeys.Forfeiture);

  return (
    <ReportCardBase
      // isUpdated
      isWideMode={isFavoriteMode}
      testId={TEST_ID}
      isFavorite={isFavorite}
      onChangeFavorite={handleToggleReportKey}
      url={ROUTES.FORFEITURE_REPORT}
      icon={
        <ForfeituresReportdIcon
          size={isFavoriteMode ? '50px' : '40px'}
          color={isFavoriteMode ? 'iconAccent' : 'iconDisabled'}
        />
      }
      title="End of Year"
      description="Easily track enrollment details, fund
movements and related information"
    />
  );
};
export default ForfeitureCard;
